import authActions from "../actions/authActions";
import helpersEncrypt from "../../helpers/encrypt";

const mainState = {
  mobile: null,

  authStatus: null,

  isUserLoggedIn: false,

  isInit: false,
  userID: null,
  firstNameUser: null,
  lastNameUser: null,
  categoryUser: null,
  role: null,

  permissionsUser: null,

  wallet: 0,
  score: 0,

  hasMessage: false,
  typeMessage: null,
  message: null,
};

const main = (state = mainState, action) => {
  let newState = state;

  switch (action.type) {
    case authActions.CHECK_USER_LOGIN_SUCCESS:
      let userInfo;
      if (action.payload.user_info != null) {
        userInfo = {
          firstNameUser: action.payload.user_info.firstName,
          lastNameUser: action.payload.user_info.lastName,
          email: action.payload.user_info.email,
          mobile: action.payload.user_info.mobile,
          role: action.payload.user_info.role_persian,
        };
        if (action.payload.user_info.category != null) {
          userInfo.categoryUser = action.payload.user_info.category;
        }
        userInfo.wallet = action.payload.wallet_publisher_user_ID;
        userInfo.score = action.payload.score_publisher_user_ID;
      }

      newState = {
        ...state,
        isUserLoggedIn: true,
        isInit: true,
        userID: action.payload.user_id,
        permissionsUser: helpersEncrypt.decryptArrayUserPermissions(
          action.payload.permissions
        ),
        ...userInfo,
      };
      break;

    case authActions.CHECK_USER_LOGIN_FAILED:
      newState = {
        ...state,
        isInit: true,
      };
      break;

    case authActions.USER_DO_LOGOUT:
      localStorage.removeItem("token");
      newState = {
        ...state,
        isUserLoggedIn: false,
      };
      break;
  }
  return newState;
};
export default main;
